package org.multiplatform.kotfolio.pages.kmm

import androidx.compose.runtime.*
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.core.Page

@Page("/kmm/realm")
@Composable
fun KMPRealmPage() {
    BlogLayout(
        PageProperties(
            "Realm Database",
            ""
        ),
        BlogProperties("KMP", "Realm Database (stevdza-san)")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            KotlinCode(
                code = """
                    [versions]
                    agp = "8.2.2"
                    android-compileSdk = "34"
                    android-minSdk = "24"
                    android-targetSdk = "34"
                    androidx-activityCompose = "1.8.2"
                    compose = "1.6.4"
                    compose-plugin = "1.6.1"
                    kotlin = "1.9.23"
                    voyager = "1.0.0"
                    koin = "3.5.3"
                    realm = "1.13.0"
                    coroutines = "1.8.0"
                    stately = "2.0.5"

                    [libraries]
                    androidx-activity-compose = { module = "androidx.activity:activity-compose", version.ref = "androidx-activityCompose" }
                    compose-ui-tooling = { module = "androidx.compose.ui:ui-tooling", version.ref = "compose" }
                    compose-ui-tooling-preview = { module = "androidx.compose.ui:ui-tooling-preview", version.ref = "compose" }
                    navigator = { module = "cafe.adriel.voyager:voyager-navigator", version.ref = "voyager" }
                    navigator-screen-model = { module = "cafe.adriel.voyager:voyager-screenmodel", version.ref = "voyager" }
                    navigator-transitions = { module = "cafe.adriel.voyager:voyager-transitions", version.ref = "voyager" }
                    navigator-koin = { module = "cafe.adriel.voyager:voyager-koin", version.ref = "voyager" }
                    koin-core = { module = "io.insert-koin:koin-core", version.ref = "koin" }
                    mongodb-realm = { module = "io.realm.kotlin:library-base", version.ref = "realm" }
                    kotlin-coroutines = { module = "org.jetbrains.kotlinx:kotlinx-coroutines-core", version.ref = "coroutines" }
                    stately-common = { module = "co.touchlab:stately-common", version.ref = "stately" }

                    [plugins]
                    androidApplication = { id = "com.android.application", version.ref = "agp" }
                    androidLibrary = { id = "com.android.library", version.ref = "agp" }
                    jetbrainsCompose = { id = "org.jetbrains.compose", version.ref = "compose-plugin" }
                    kotlinMultiplatform = { id = "org.jetbrains.kotlin.multiplatform", version.ref = "kotlin" }
                    realm-plugin = { id = "io.realm.kotlin", version.ref = "realm" }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import org.jetbrains.compose.desktop.application.dsl.TargetFormat

                    plugins {
                        alias(libs.plugins.kotlinMultiplatform)
                        alias(libs.plugins.androidApplication)
                        alias(libs.plugins.jetbrainsCompose)
                        alias(libs.plugins.realm.plugin)
                    }

                    kotlin {
                        androidTarget {
                            compilations.all {
                                kotlinOptions {
                                    jvmTarget = "11"
                                }
                            }
                        }
                        
                        listOf(
                            iosX64(),
                            iosArm64(),
                            iosSimulatorArm64()
                        ).forEach { iosTarget ->
                            iosTarget.binaries.framework {
                                baseName = "ComposeApp"
                                isStatic = true
                            }
                        }
                        
                        sourceSets {
                            
                            androidMain.dependencies {
                                implementation(libs.compose.ui.tooling.preview)
                                implementation(libs.androidx.activity.compose)
                            }
                            commonMain.dependencies {
                                implementation(compose.runtime)
                                implementation(compose.foundation)
                                implementation(compose.material3)
                                implementation(compose.ui)
                                implementation(compose.components.resources)
                                implementation(compose.components.uiToolingPreview)

                                implementation(libs.navigator)
                                implementation(libs.navigator.screen.model)
                                implementation(libs.navigator.transitions)
                                implementation(libs.navigator.koin)
                                implementation(libs.koin.core)

                                implementation(libs.mongodb.realm)
                                implementation(libs.kotlin.coroutines)
                                implementation(libs.stately.common)
                            }
                        }
                    }

                    android {
                        namespace = "com.multiplatform.todo"
                        compileSdk = libs.versions.android.compileSdk.get().toInt()

                        sourceSets["main"].manifest.srcFile("src/androidMain/AndroidManifest.xml")
                        sourceSets["main"].res.srcDirs("src/androidMain/res")
                        sourceSets["main"].resources.srcDirs("src/commonMain/resources")

                        defaultConfig {
                            applicationId = "com.multiplatform.todo"
                            minSdk = libs.versions.android.minSdk.get().toInt()
                            targetSdk = libs.versions.android.targetSdk.get().toInt()
                            versionCode = 1
                            versionName = "1.0"
                        }
                        packaging {
                            resources {
                                excludes += "/META-INF/{AL2.0,LGPL2.1}"
                            }
                        }
                        buildTypes {
                            getByName("release") {
                                isMinifyEnabled = false
                            }
                        }
                        compileOptions {
                            sourceCompatibility = JavaVersion.VERSION_11
                            targetCompatibility = JavaVersion.VERSION_11
                        }
                        dependencies {
                            debugImplementation(libs.compose.ui.tooling)
                        }
                    }

                    task("testClasses") {}
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    plugins {
                        // this is necessary to avoid the plugins to be loaded multiple times
                        // in each subproject's classloader
                        alias(libs.plugins.androidApplication) apply false
                        alias(libs.plugins.androidLibrary) apply false
                        alias(libs.plugins.jetbrainsCompose) apply false
                        alias(libs.plugins.kotlinMultiplatform) apply false
                        alias(libs.plugins.realm.plugin) apply false
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                    //data/MongoDB.kt
                    
                    import domain.RequestState
                    import domain.ToDoTask
                    import io.realm.kotlin.Realm
                    import io.realm.kotlin.RealmConfiguration
                    import io.realm.kotlin.ext.query
                    import kotlinx.coroutines.flow.Flow
                    import kotlinx.coroutines.flow.flow
                    import kotlinx.coroutines.flow.map

                    class MongoDB {
                        private var realm: Realm? = null
                        init {
                            configureTheRealm()
                        }
                        private fun configureTheRealm() {
                            if (realm == null || realm!!.isClosed()) {
                                val config = RealmConfiguration.Builder(
                                    schema = setOf(ToDoTask::class)
                                )
                                    .compactOnLaunch()
                                    .build()
                                realm = Realm.open(config)
                            }
                        }

                        fun readActiveTasks(): Flow<RequestState<List<ToDoTask>>> {
                            return realm?.query<ToDoTask>(query = "completed == $0", false)
                                ?.asFlow()
                                ?.map { result ->
                                    RequestState.Success(
                                        data = result.list.sortedByDescending { task -> task.favorite }
                                    )
                                } ?: flow { RequestState.Error(message = "Realm is not available.") }
                        }

                        fun readCompletedTasks(): Flow<RequestState<List<ToDoTask>>> {
                            return realm?.query<ToDoTask>(query = "completed == $0", true)
                                ?.asFlow()
                                ?.map { result -> RequestState.Success(data = result.list) }
                                ?: flow { RequestState.Error(message = "Realm is not available.") }
                        }

                        suspend fun addTask(task: ToDoTask) {
                            realm?.write { copyToRealm(task) }
                        }

                        suspend fun updateTask(task: ToDoTask) {
                            realm?.write {
                                try {
                                    val queriedTask = query<ToDoTask>("_id == $0", task._id)
                                        .first()
                                        .find()
                                    queriedTask?.let {
                                        findLatest(it)?.let { currentTask ->
                                            currentTask.title = task.title
                                            currentTask.description = task.description
                                        }
                                    }
                                } catch (e: Exception) {
                                    println(e)
                                }
                            }
                        }

                        suspend fun setCompleted(task: ToDoTask, taskCompleted: Boolean) {
                            realm?.write {
                                try {
                                    val queriedTask = query<ToDoTask>(query = "_id == $0", task._id)
                                        .find()
                                        .first()
                                    queriedTask.apply { completed = taskCompleted }
                                } catch (e: Exception) {
                                    println(e)
                                }
                            }
                        }

                        suspend fun setFavorite(task: ToDoTask, isFavorite: Boolean) {
                            realm?.write {
                                try {
                                    val queriedTask = query<ToDoTask>(query = "_id == $0", task._id)
                                        .find()
                                        .first()
                                    queriedTask.apply { favorite = isFavorite }
                                } catch (e: Exception) {
                                    println(e)
                                }
                            }
                        }

                        suspend fun deleteTask(task: ToDoTask) {
                            realm?.write {
                                try {
                                    val queriedTask = query<ToDoTask>(query = "_id == $0", task._id)
                                        .first()
                                        .find()
                                    queriedTask?.let {
                                        findLatest(it)?.let { currentTask ->
                                            delete(currentTask)
                                        }
                                    }
                                } catch (e: Exception) {
                                    println(e)
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //domain/RequestState.kt
                    
                    import androidx.compose.animation.AnimatedContent
                    import androidx.compose.animation.AnimatedContentTransitionScope
                    import androidx.compose.animation.ContentTransform
                    import androidx.compose.animation.core.tween
                    import androidx.compose.animation.fadeIn
                    import androidx.compose.animation.fadeOut
                    import androidx.compose.animation.togetherWith
                    import androidx.compose.runtime.Composable
                    
                    sealed class RequestState<out T> {
                        data object Idle : RequestState<Nothing>()
                        data object Loading : RequestState<Nothing>()
                        data class Success<T>(val data: T) : RequestState<T>()
                        data class Error(val message: String) : RequestState<Nothing>()

                        fun isLoading() = this is Loading
                        fun isSuccess() = this is Success
                        fun isError() = this is Error

                        /**
                         * Returns data from a [Success].
                         * @throws ClassCastException If the current state is not [Success]
                         *  */
                        fun getSuccessData() = (this as Success).data
                        fun getSuccessDataOrNull(): T? {
                            return try {
                                (this as Success).data
                            } catch (e: Exception) {
                                null
                            }
                        }

                        /**
                         * Returns an error message from an [Error]
                         * @throws ClassCastException If the current state is not [Error]
                         *  */
                        fun getErrorMessage() = (this as Error).message
                        fun getErrorMessageOrEmpty(): String {
                            return try {
                                (this as Error).message
                            } catch (e: Exception) {
                                ""
                            }
                        }

                        @Composable
                        fun DisplayResult(
                            onIdle: (@Composable () -> Unit)? = null,
                            onLoading: @Composable () -> Unit,
                            onSuccess: @Composable (T) -> Unit,
                            onError: @Composable (String) -> Unit,
                            transitionSpec: AnimatedContentTransitionScope<*>.() -> ContentTransform = {
                                fadeIn(tween(durationMillis = 300)) togetherWith
                                        fadeOut(tween(durationMillis = 300))
                            }
                        ) {
                            AnimatedContent(
                                targetState = this,
                                transitionSpec = transitionSpec,
                                label = "Animated State"
                            ) { state ->
                                when (state) {
                                    is Idle -> {
                                        onIdle?.invoke()
                                    }

                                    is Loading -> {
                                        onLoading()
                                    }

                                    is Success -> {
                                        onSuccess(state.getSuccessData())
                                    }

                                    is Error -> {
                                        onError(state.getErrorMessage())
                                    }
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //domain/TaskAction.kt
                    
                    sealed class TaskAction {
                        data class Add(val task: ToDoTask) : TaskAction()
                        data class Update(val task: ToDoTask) : TaskAction()
                        data class Delete(val task: ToDoTask) : TaskAction()
                        data class SetCompleted(val task: ToDoTask, val completed: Boolean) : TaskAction()
                        data class SetFavorite(val task: ToDoTask, val isFavorite: Boolean) : TaskAction()
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //domain/ToDoTask.kt
                    
                    class ToDoTask: RealmObject {
                        @PrimaryKey
                        var _id: ObjectId = ObjectId()
                        var title: String = ""
                        var description: String = ""
                        var favorite: Boolean = false
                        var completed: Boolean = false
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //presentation/components/ErrorScreen.kt
                    
                    @Composable
                    fun ErrorScreen(message: String? = null) {
                        Box(
                            modifier = Modifier
                                .fillMaxSize()
                                .padding(all = 24.dp),
                            contentAlignment = Alignment.Center
                        ) {
                            Text(text = message ?: "Empty")
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //presentation/components/LoadingScreen.kt
                    
                    @Composable
                    fun LoadingScreen() {
                        Box(
                            modifier = Modifier
                                .fillMaxSize()
                                .padding(all = 24.dp),
                            contentAlignment = Alignment.Center
                        ) {
                            CircularProgressIndicator(modifier = Modifier.size(28.dp))
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                     //presentation/components/TaskView.kt
                     
                     @OptIn(ExperimentalResourceApi::class)
                     @Composable
                     fun TaskView(
                         task: ToDoTask,
                         showActive: Boolean = true,
                         onSelect: (ToDoTask) -> Unit,
                         onComplete: (ToDoTask, Boolean) -> Unit,
                         onFavorite: (ToDoTask, Boolean) -> Unit,
                         onDelete: (ToDoTask) -> Unit
                     ) {
                         Row(
                             modifier = Modifier
                                 .fillMaxWidth()
                                 .clickable {
                                     if (showActive) onSelect(task)
                                     else onDelete(task)
                                 },
                             verticalAlignment = Alignment.CenterVertically,
                             horizontalArrangement = Arrangement.SpaceBetween
                         ) {
                             Row(verticalAlignment = Alignment.CenterVertically) {
                                 Checkbox(
                                     checked = task.completed,
                                     onCheckedChange = { onComplete(task, !task.completed) },
                                 )
                                 Spacer(modifier = Modifier.width(8.dp))
                                 Text(
                                     modifier = Modifier.alpha(if (showActive) 1f else 0.5f),
                                     text = task.title,
                                     fontSize = MaterialTheme.typography.bodyMedium.fontSize,
                                     textDecoration = if (showActive) TextDecoration.None
                                     else TextDecoration.LineThrough
                                 )
                             }
                             IconButton(
                                 onClick = {
                                     if (showActive) onFavorite(task, !task.favorite)
                                     else onDelete(task)
                                 }
                             ) {
                                 Icon(
                                     painter = painterResource(
                                         if (showActive) Res.drawable.star
                                         else Res.drawable.delete
                                     ),
                                     contentDescription = "Favorite Icon",
                                     tint = if (task.favorite) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.onSurface.copy(
                                         alpha = 0.38f
                                     )
                                 )
                             }
                         }
                     }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    
                    class HomeScreen : Screen {
                        @OptIn(ExperimentalMaterial3Api::class)
                        @Composable
                        override fun Content() {
                            val navigator = LocalNavigator.currentOrThrow
                            val viewModel = getScreenModel<HomeViewModel>()
                            val activeTasks by viewModel.activeTasks
                            val completedTasks by viewModel.completedTasks

                            Scaffold(
                                topBar = {
                                    CenterAlignedTopAppBar(title = { Text(text = "Home") })
                                },
                                floatingActionButton = {
                                    FloatingActionButton(
                                        onClick = { navigator.push(TaskScreen()) },
                                        shape = RoundedCornerShape(size = 12.dp)
                                    ) {
                                        Icon(
                                            imageVector = Icons.Default.Edit,
                                            contentDescription = "Edit Icon"
                                        )
                                    }
                                }
                            ) { padding ->
                                Column(
                                    modifier = Modifier
                                        .fillMaxSize()
                                        .padding(top = 24.dp)
                                        .padding(
                                            top = padding.calculateTopPadding(),
                                            bottom = padding.calculateBottomPadding()
                                        )
                                ) {
                                    DisplayTasks(
                                        modifier = Modifier.weight(1f),
                                        tasks = activeTasks,
                                        onSelect = { selectedTask ->
                                            navigator.push(TaskScreen(selectedTask))
                                        },
                                        onFavorite = { task, isFavorite ->
                                            viewModel.setAction(
                                                action = TaskAction.SetFavorite(task, isFavorite)
                                            )
                                        },
                                        onComplete = { task, completed ->
                                            viewModel.setAction(
                                                action = TaskAction.SetCompleted(task, completed)
                                            )
                                        }
                                    )
                                    Spacer(modifier = Modifier.height(24.dp))
                                    DisplayTasks(
                                        modifier = Modifier.weight(1f),
                                        tasks = completedTasks,
                                        showActive = false,
                                        onComplete = { task, completed ->
                                            viewModel.setAction(
                                                action = TaskAction.SetCompleted(task, completed)
                                            )
                                        },
                                        onDelete = { task ->
                                            viewModel.setAction(
                                                action = TaskAction.Delete(task)
                                            )
                                        }
                                    )
                                }
                            }
                        }
                    }

                    @Composable
                    fun DisplayTasks(
                        modifier: Modifier = Modifier,
                        tasks: RequestState<List<ToDoTask>>,
                        showActive: Boolean = true,
                        onSelect: ((ToDoTask) -> Unit)? = null,
                        onFavorite: ((ToDoTask, Boolean) -> Unit)? = null,
                        onComplete: (ToDoTask, Boolean) -> Unit,
                        onDelete: ((ToDoTask) -> Unit)? = null
                    ) {
                        var showDialog by remember { mutableStateOf(false) }
                        var taskToDelete: ToDoTask? by remember { mutableStateOf(null) }

                        if (showDialog) {
                            AlertDialog(
                                title = {
                                    Text(text = "Delete", fontSize = MaterialTheme.typography.titleLarge.fontSize)
                                },
                                text = {
                                    Text(
                                        text = "Are you sure you want to remove {taskToDelete!!.title} task?",
                                        fontSize = MaterialTheme.typography.bodyMedium.fontSize
                                    )
                                },
                                confirmButton = {
                                    Button(onClick = {
                                        onDelete?.invoke(taskToDelete!!)
                                        showDialog = false
                                        taskToDelete = null
                                    }) {
                                        Text(text = "Yes")
                                    }
                                },
                                dismissButton = {
                                    TextButton(
                                        onClick = {
                                            taskToDelete = null
                                            showDialog = false
                                        }
                                    ) {
                                        Text(text = "Cancel")
                                    }
                                },
                                onDismissRequest = {
                                    taskToDelete = null
                                    showDialog = false
                                }
                            )
                        }

                        Column(modifier = modifier.fillMaxWidth()) {
                            Text(
                                modifier = Modifier.padding(horizontal = 12.dp),
                                text = if (showActive) "Active Tasks" else "Completed Tasks",
                                fontSize = MaterialTheme.typography.titleMedium.fontSize,
                                fontWeight = FontWeight.Medium
                            )
                            Spacer(modifier = Modifier.height(12.dp))
                            tasks.DisplayResult(
                                onLoading = { LoadingScreen() },
                                onError = { ErrorScreen(message = it) },
                                onSuccess = {
                                    if (it.isNotEmpty()) {
                                        LazyColumn(modifier = Modifier.padding(horizontal = 24.dp)) {
                                            items(
                                                items = it,
                                                key = { task -> task._id.toHexString() }
                                            ) { task ->
                                                TaskView(
                                                    showActive = showActive,
                                                    task = task,
                                                    onSelect = { onSelect?.invoke(task) },
                                                    onComplete = { selectedTask, completed ->
                                                        onComplete(selectedTask, completed)
                                                    },
                                                    onFavorite = { selectedTask, favorite ->
                                                        onFavorite?.invoke(selectedTask, favorite)
                                                    },
                                                    onDelete = { selectedTask ->
                                                        taskToDelete = selectedTask
                                                        showDialog = true
                                                    }
                                                )
                                            }
                                        }
                                    } else {
                                        ErrorScreen()
                                    }
                                }
                            )
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    typealias MutableTasks = MutableState<RequestState<List<ToDoTask>>>
                    typealias Tasks = MutableState<RequestState<List<ToDoTask>>>

                    class HomeViewModel(private val mongoDB: MongoDB) : ScreenModel {
                        private var _activeTasks: MutableTasks = mutableStateOf(RequestState.Idle)
                        val activeTasks: Tasks = _activeTasks

                        private var _completedTasks: MutableTasks = mutableStateOf(RequestState.Idle)
                        val completedTasks: Tasks = _completedTasks

                        init {
                            _activeTasks.value = RequestState.Loading
                            _completedTasks.value = RequestState.Loading
                            screenModelScope.launch(Dispatchers.Main) {
                                mongoDB.readActiveTasks().collectLatest {
                                    _activeTasks.value = it
                                }
                            }
                            screenModelScope.launch(Dispatchers.Main) {
                                mongoDB.readCompletedTasks().collectLatest {
                                    _completedTasks.value = it
                                }
                            }
                        }

                        fun setAction(action: TaskAction) {
                            when (action) {
                                is TaskAction.Delete -> {
                                    deleteTask(action.task)
                                }

                                is TaskAction.SetCompleted -> {
                                    setCompleted(action.task, action.completed)
                                }

                                is TaskAction.SetFavorite -> {
                                    setFavorite(action.task, action.isFavorite)
                                }

                                else -> {}
                            }
                        }

                        private fun setCompleted(task: ToDoTask, completed: Boolean) {
                            screenModelScope.launch(Dispatchers.IO) {
                                mongoDB.setCompleted(task, completed)
                            }
                        }

                        private fun setFavorite(task: ToDoTask, isFavorite: Boolean) {
                            screenModelScope.launch(Dispatchers.IO) {
                                mongoDB.setFavorite(task, isFavorite)
                            }
                        }

                        private fun deleteTask(task: ToDoTask) {
                            screenModelScope.launch(Dispatchers.IO) {
                                mongoDB.deleteTask(task)
                            }
                        }
                    }  
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        const val DEFAULT_TITLE = "Enter the Title"
                        const val DEFAULT_DESCRIPTION = "Add some description"
                        data class TaskScreen(val task: ToDoTask? = null) : Screen {
                            @OptIn(ExperimentalMaterial3Api::class)
                            @Composable
                            override fun Content() {
                                val navigator = LocalNavigator.currentOrThrow
                                val viewModel = getScreenModel<TaskViewModel>()
                                var currentTitle by remember {
                                    mutableStateOf(task?.title ?: DEFAULT_TITLE)
                                }
                                var currentDescription by remember {
                                    mutableStateOf(task?.description ?: DEFAULT_DESCRIPTION)
                                }

                                Scaffold(
                                    topBar = {
                                        TopAppBar(
                                            title = {
                                                BasicTextField(
                                                    textStyle = TextStyle(
                                                        color = MaterialTheme.colorScheme.onSurface,
                                                        fontSize = MaterialTheme.typography.titleLarge.fontSize
                                                    ),
                                                    singleLine = true,
                                                    value = currentTitle,
                                                    onValueChange = { currentTitle = it }
                                                )
                                            },
                                            navigationIcon = {
                                                IconButton(onClick = { navigator.pop() }) {
                                                    Icon(
                                                        imageVector = Icons.AutoMirrored.Default.ArrowBack,
                                                        contentDescription = "Back Arrow"
                                                    )
                                                }
                                            }
                                        )
                                    },
                                    floatingActionButton = {
                                        if (currentTitle.isNotEmpty() && currentDescription.isNotEmpty()) {
                                            FloatingActionButton(
                                                onClick = {
                                                    if (task != null) {
                                                        viewModel.setAction(
                                                            action = TaskAction.Update(
                                                                ToDoTask().apply {
                                                                    _id = task._id
                                                                    title = currentTitle
                                                                    description = currentDescription
                                                                }
                                                            )
                                                        )
                                                    } else {
                                                        viewModel.setAction(
                                                            action = TaskAction.Add(
                                                                ToDoTask().apply {
                                                                    title = currentTitle
                                                                    description = currentDescription
                                                                }
                                                            )
                                                        )
                                                    }
                                                    navigator.pop()
                                                },
                                                shape = RoundedCornerShape(size = 12.dp)
                                            ) {
                                                Icon(
                                                    imageVector = Icons.Default.Check,
                                                    contentDescription = "Checkmark Icon"
                                                )
                                            }
                                        }
                                    }
                                ) { padding ->
                                    BasicTextField(
                                        modifier = Modifier
                                            .fillMaxSize()
                                            .padding(all = 24.dp)
                                            .padding(
                                                top = padding.calculateTopPadding(),
                                                bottom = padding.calculateBottomPadding()
                                            ),
                                        textStyle = TextStyle(
                                            fontSize = MaterialTheme.typography.titleMedium.fontSize,
                                            color = MaterialTheme.colorScheme.onSurface
                                        ),
                                        value = currentDescription,
                                        onValueChange = { description -> currentDescription = description }
                                    )
                                }
                            }
                        }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    class TaskViewModel(
                        private val mongoDB: MongoDB
                    ): ScreenModel {
                        fun setAction(action: TaskAction) {
                            when (action) {
                                is TaskAction.Add -> {
                                    addTask(action.task)
                                }

                                is TaskAction.Update -> {
                                    updateTask(action.task)
                                }

                                else -> {}
                            }
                        }

                        private fun addTask(task: ToDoTask) {
                            screenModelScope.launch(Dispatchers.IO) {
                                mongoDB.addTask(task)
                            }
                        }

                        private fun updateTask(task: ToDoTask) {
                            screenModelScope.launch(Dispatchers.IO) {
                                mongoDB.updateTask(task)
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    val lightRedColor = Color(color = 0xFFF57D88)
                    val darkRedColor = Color(color = 0xFF77000B)

                    @Composable
                    @Preview
                    fun App() {
                        initializeKoin()

                        val lightColors = lightColorScheme(
                            primary = lightRedColor,
                            onPrimary = darkRedColor,
                            primaryContainer = lightRedColor,
                            onPrimaryContainer = darkRedColor
                        )
                        val darkColors = darkColorScheme(
                            primary = lightRedColor,
                            onPrimary = darkRedColor,
                            primaryContainer = lightRedColor,
                            onPrimaryContainer = darkRedColor
                        )
                        val colors by mutableStateOf(
                            if (isSystemInDarkTheme()) darkColors else lightColors
                        )

                        MaterialTheme(colorScheme = colors) {
                            Navigator(HomeScreen()) {
                                SlideTransition(it)
                            }
                        }
                    }

                    val mongoModule = module {
                        single { MongoDB() }
                        factory { HomeViewModel(get()) }
                        factory { TaskViewModel(get()) }
                    }

                    fun initializeKoin() {
                        startKoin {
                            modules(mongoModule)
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //ROOM 
                    
                    import app.cash.sqldelight.coroutines.asFlow
                    import app.cash.sqldelight.coroutines.mapToList

                    class LocalDataSource(
                        database: ShopSampleDatabase,
                    ) {
                        private val favoritesTable = database.favoritesQueries
                        private val checkoutTable = database.checkoutQueries

                        fun getFavorites(): Flow<List<Favorites>> {
                            return favoritesTable.getFavorites()
                                .asFlow()
                                .mapToList(Dispatchers.IO)
                        }

                        fun getFavoriteByTitle(title: String): Favorites? {
                            return favoritesTable.getFavoriteTitle(title).executeAsList().firstOrNull()
                        }

                        fun saveFavorite(product: ProductUI, discount: Double) {
                            favoritesTable.saveFavorite(
                                title = product.title,
                                newPrice = product.newPrice,
                                oldPrice = product.oldPrice,
                                description = product.description,
                                image = product.images.first(),
                                timestamp = Clock.System.now().toEpochMilliseconds(),
                                category = product.category,
                                discount = discount.toString(),
                            )
                        }

                        fun removeFavorite(product: ProductUI) {
                            val favorite = favoritesTable.getFavoriteTitle(product.title).executeAsList()
                            favorite.forEach {
                                favoritesTable.removeFavoriteById(it.id)
                            }
                        }

                        fun addToCheckout(product: ProductUI) {
                            checkoutTable.addToCheckout(
                                title = product.title,
                                price = product.newPrice,
                                oldPrice = product.oldPrice,
                                description = product.description,
                                image = product.images.firstOrNull() ?: "",
                                category = product.category,
                                timestamp = Clock.System.now().toEpochMilliseconds(),
                                sizeSelected = product.sizeSelected ?: "40"
                            )
                        }

                        fun getCheckoutItems(): Flow<List<Checkout>> {
                            return checkoutTable
                                .getCheckoutItems()
                                .asFlow()
                                .mapToList(Dispatchers.IO)
                        }

                        fun removeFromCheckout(checkoutItem: CheckoutUI) {
                            checkoutTable.getCartItemById(checkoutItem.title).executeAsList().let { product ->
                                product.forEach {
                                    checkoutTable.removeFromCheckout(it.id)
                                }
                            }
                        }
                    }
                    
                    CREATE TABLE checkout(
                        id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT,
                        title TEXT NOT NULL,
                        price TEXT NOT NULL,
                        oldPrice TEXT NOT NULL,
                        description TEXT NOT NULL,
                        image TEXT NOT NULL,
                        timestamp INTEGER NOT NULL,
                        category TEXT NOT NULL,
                        sizeSelected TEXT NOT NULL
                    );

                    getCheckoutItems:
                    SELECT *
                    FROM checkout
                    ORDER BY timestamp DESC;

                    getCartItemById:
                    SELECT *
                    FROM checkout
                    WHERE title = ?;

                    removeFromCheckout:
                    DELETE FROM checkout
                    WHERE id = ?;

                    addToCheckout:
                    INSERT OR REPLACE
                    INTO checkout(
                        title,
                        price,
                        oldPrice,
                        description,
                        image,
                        timestamp,
                        category,
                        sizeSelected
                    )
                    VALUES(?, ?, ?, ?, ?, ?,?, ?);
                    
                    //favorites.sq
                    CREATE TABLE favorites(
                        id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT,
                        title TEXT NOT NULL,
                        newPrice TEXT NOT NULL,
                        oldPrice TEXT NOT NULL,
                        description TEXT NOT NULL,
                        image TEXT NOT NULL,
                        timestamp INTEGER NOT NULL,
                        category TEXT NOT NULL,
                        discount TEXT NOT NULL
                    );

                    getFavorites:
                    SELECT *
                    FROM favorites
                    ORDER BY timestamp DESC;

                    getFavoriteTitle:
                    SELECT *
                    FROM favorites
                    WHERE title = ?;

                    removeFavoriteById:
                    DELETE FROM favorites
                    WHERE id = ?;

                    saveFavorite:
                    INSERT OR REPLACE
                    INTO favorites(
                        title,
                        newPrice,
                        oldPrice,
                        description,
                        image,
                        timestamp,
                        category,
                        discount
                    )
                    VALUES(?, ?, ?, ?, ?, ?, ?, ?);
                """.trimIndent()
            )
        }
    }
}

//https://github.com/synapseSRC/synapseApp